import React from "react";
import { Input } from "semantic-ui-react";

const OrdersFilter = (props) => {
  return (
    <Input
      fluid
      onChange={props.onInputChange}
      placeholder={props.placeholder}
      size="large"
      icon="search"
    />
  );
};

export default OrdersFilter;
